/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Timecode_OffsetInputs */

const en_apply_timecode_offset = /** @type {(inputs: Apply_Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply timecode offset`)
};

const fr_apply_timecode_offset = /** @type {(inputs: Apply_Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer le décalage de timecode`)
};

const de_apply_timecode_offset = /** @type {(inputs: Apply_Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode-Offset anwenden`)
};

const it_apply_timecode_offset = /** @type {(inputs: Apply_Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica offset del codice temporale`)
};

const ru_apply_timecode_offset = /** @type {(inputs: Apply_Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применить смещение временного кода`)
};

const es_apply_timecode_offset = /** @type {(inputs: Apply_Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar desplazamiento de código de tiempo`)
};

const zh_cn2_apply_timecode_offset = /** @type {(inputs: Apply_Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用时间码偏移`)
};

const ja_apply_timecode_offset = /** @type {(inputs: Apply_Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードオフセットを適用する`)
};

const hi_apply_timecode_offset = /** @type {(inputs: Apply_Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड ऑफ़सेट लागू करें`)
};

const pt_pt2_apply_timecode_offset = /** @type {(inputs: Apply_Timecode_OffsetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar deslocamento de código de tempo`)
};

/**
* | output |
* | --- |
* | "Apply timecode offset" |
*
* @param {Apply_Timecode_OffsetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_timecode_offset = /** @type {((inputs?: Apply_Timecode_OffsetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Timecode_OffsetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_apply_timecode_offset(inputs)
	if (locale === "de") return de_apply_timecode_offset(inputs)
	if (locale === "it") return it_apply_timecode_offset(inputs)
	if (locale === "ru") return ru_apply_timecode_offset(inputs)
	if (locale === "es") return es_apply_timecode_offset(inputs)
	if (locale === "zh-CN") return zh_cn2_apply_timecode_offset(inputs)
	if (locale === "ja") return ja_apply_timecode_offset(inputs)
	if (locale === "hi") return hi_apply_timecode_offset(inputs)
	if (locale === "pt-PT") return pt_pt2_apply_timecode_offset(inputs)
	return en_apply_timecode_offset(inputs)
});